export class ProjectUserDto{
    id!:string;
    email!: string;
    firstName!: string;
    lastName!: string;
    projectId!:string;
    userName!:string;
}

export class ProjectUsersDto {

    pageSize!: number;
    totalCount!: number;
    projectUsers!: ProjectUserDto[];
}